module.exports = __webpack_public_path__ + "static/img/banner3.06b7b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3.jpg
// module id = GWCu
// module chunks = 12